<template>
    <div class="two-step-container">
        <div class="row mx-0">
            <div class="offset-md-1 col-md-6 px-0">
                <two-step-instructions/>
            </div>
            <div class="col-md-5 px-0 faq-container">
                <two-step-faq/>
            </div>
        </div>
    </div>
</template>

<script>
    import TwoStepFaq from "@/components/TwoStepFaq.vue";
    import TwoStepInstructions from "@/components/TwoStepInstructions";

    export default {
        name: 'TwoStepBody',
        components: {
            TwoStepFaq,
            TwoStepInstructions,
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .two-step-container {
        background:#ffffff;
        line-height: normal;
    }

    @media (max-width: 750px) {
        .two-step-faq{
            min-width: 100%;
        }
        .two-step-form {
            min-width: 100% !important;
        }
    }

    @media (max-width: 400px) {
        .two-step-faq {
            margin-bottom: 20px;
        }
    }
    .faq-container{
      background-color: #F1F1F1;
    }

</style>
